import React from 'react';
import loading from './giphy.gif'

const LoadingIndicator = () => {
    return <img src = {loading}  style={{margin:"300px",  width:"200px"}} alt="loading indicator"/>

}



export default LoadingIndicator;  